import { Component, Vue, Watch } from 'vue-property-decorator'

import dateHelper from '@/helpers/date'

import EmailLog from '../EmailLog/index.vue'
import AuditLog from '../AuditLog/index.vue'
import ModalAuditoria from '../ModalAuditoria/index.vue'
import ModalArquivados from '../ModalArquivados/index.vue'
import Loader from '@/components/Loader/index.vue'
import FieldDatePortal from '@/components/edit/FieldDatePortal/index.vue'

import { library } from '@fortawesome/fontawesome-svg-core'
import {
	faPlusCircle,
	faExternalLinkAlt,
	faFilePdf,
	faStarHalfStroke,
	faPenClip,
	faFilter,
	faCirclePlus,
} from '@fortawesome/free-solid-svg-icons'

import { faBlackTie } from '@fortawesome/free-brands-svg-icons'
import fetch from '@/helpers/fetch'

import Control from '@/helpers/control'

library.add(
	faPlusCircle,
	faExternalLinkAlt,
	faFilePdf,
	faStarHalfStroke,
	faPenClip,
	faBlackTie,
	faFilter,
	faCirclePlus,
)

@Component({
	components: {
		EmailLog,
		AuditLog,
		ModalAuditoria,
		ModalArquivados,
		Loader,
		FieldDatePortal,
	},
})
export default class Administrative extends Vue {
	loading = false
	clients = [] as any[]
	seeAll = ''
	signatureTemplate = ''
	emailType: 'automatico' | 'especifico' = 'automatico'
	auditoriaSelecionada: any = null
	auditorias: any[] = []
	loadingAuditorias = false

	async loadAuditorias() {
		this.loadingAuditorias = true
		try {
			const res = await fetch.get('/api/audits')
			this.auditorias = res.data || []
		} finally {
			this.loadingAuditorias = false
		}
	}

	onAuditoriaSaved(auditoria: any) {
		const idx = this.auditorias.findIndex((a) => a.id === auditoria.id)
		if (idx >= 0) {
			this.auditorias.splice(idx, 1, auditoria)
		} else {
			this.auditorias.push(auditoria)
		}
		this.auditorias = this.auditorias.filter(
			(a) => a.status !== 'Arquivado',
		)
	}

	get auditoriasByDeadline(): { deadline: string; items: any[] }[] {
		const groups: Record<string, any[]> = {}
		for (const a of this.auditorias) {
			const key = a.response_deadline || ''
			if (!groups[key]) groups[key] = []
			groups[key].push(a)
		}
		return Object.keys(groups).map((deadline) => ({
			deadline,
			items: groups[deadline],
		}))
	}

	formatDeadline(dateStr: string): string {
		if (!dateStr) return '—'
		const [year, month, day] = dateStr.split('-')
		if (!year || !month || !day) return dateStr
		return `${day}/${month}/${year}`
	}

	setEmailType(type: 'automatico' | 'especifico') {
		this.emailType = type
		const hash =
			type === 'especifico'
				? '#administrativo-especifico'
				: '#administrativo'
		if (this.$route.hash !== hash) {
			this.$router.replace({ hash })
		}
		this.$store.dispatch('saveCurrentFullPath', this.$route.fullPath)
		if (type === 'especifico' && !this.auditorias.length) {
			this.loadAuditorias()
		}
	}

	@Watch('$route.hash')
	onRouteHashChange(hash: string) {
		if (
			hash !== '#administrativo' &&
			hash !== '#administrativo-especifico'
		) {
			return
		}
		const type =
			hash === '#administrativo-especifico' ? 'especifico' : 'automatico'
		if (this.emailType !== type) {
			this.emailType = type
			if (type === 'especifico' && !this.auditorias.length) {
				this.loadAuditorias()
			}
		}
	}

	filterDate = new Date()
	filterDateShow = ''

	async mounted() {
		if (this.$route.hash === '#administrativo-especifico') {
			this.emailType = 'especifico'
			this.loadAuditorias()
		}
		this.seeAll = this.$route.params.seeAll
		let monthYear

		if (this.seeAll) {
			if (this.filterDate) {
				const dateObj = new Date(this.filterDate)
				const month = String(dateObj.getMonth() + 1).padStart(2, '0')
				const year = dateObj.getFullYear()
				this.filterDateShow = `${month}/${year}`

				monthYear = `${year}-${month}`
			}
		}

		// this.$store.dispatch('saveCurrentFullPath', this.$route.fullPath)
		this.loading = true

		const result = await Promise.all([
			this.$store.dispatch('fetchEmailLogsAdm', {
				seeAll: this.seeAll === 'ver-todos',
				date: monthYear,
			}),
			// fetch.get('/api/email_logs/signature'),
		])

		// this.signatureTemplate = result?.[1]?.signatureTemplate

		this.loading = false

		this.loadClientsOptions()
	}

	async loadClientsOptions() {
		const res = await fetch.get('/api/groups')
		if (res.ok) {
			const filtered = res?.data.filter((group) => {
				// Verifica se todos os trials estão fechados
				function allTrialsClosed() {
					return group.groupsRelations.every(
						(relation) => relation.trialAdm?.closed,
					)
				}

				// Verifica se há pelo menos um trialAdm no grupo
				function hasTrialAdm() {
					return group.groupsRelations.some(
						(relation) => relation.trialAdm,
					)
				}

				return !allTrialsClosed() && hasTrialAdm()
			})

			this.clients.push(...filtered)

			filtered.forEach((client) => {
				this.clientsById[client.id] = client
			})
		}
	}

	get emailsGroupedByDate() {
		return this.$store.state.emailsadm.emailsGroupedByDate
	}

	get dates() {
		return sortByDate(this.emailsGroupedByDate)
	}

	// get emailsGroupedByDate() {
	// 	return {
	// 		'2024-09-10': [
	// 			{
	// 				email: 'email1@example.com',
	// 				subject: 'Assunto 1',
	// 				date: '2024-09-10',
	// 				status: 'aprovado',
	// 				id: 101,
	// 				group: {
	// 					name: 'Grupo A',
	// 					reportSendingFrom: {
	// 						name: 'Remetente 1',
	// 					},
	// 					reviewer: {
	// 						name: 'fulano',
	// 					},
	// 					elaborator: {
	// 						name: 'ciclano',
	// 					},
	// 				},
	// 			},
	// 			{
	// 				email: 'email2@example.com',
	// 				subject: 'Assunto 2',
	// 				date: '2024-09-10',
	// 				status: 'nao_aprovado',
	// 				id: 102,
	// 				group: {
	// 					name: 'Grupo B',
	// 					reportSendingFrom: {
	// 						name: 'Remetente 2',
	// 					},
	// 					reviewer: {
	// 						name: 'fulano',
	// 					},
	// 					elaborator: {
	// 						name: 'ciclano',
	// 					},
	// 				},
	// 			},
	// 		],
	// 		'2024-09-11': [
	// 			{
	// 				email: 'email3@example.com',
	// 				subject: 'Assunto 3',
	// 				date: '2024-09-11',
	// 				status: 'pendente',
	// 				id: 103,
	// 				group: {
	// 					name: 'Grupo C',
	// 					reportSendingFrom: {
	// 						name: 'Remetente 3',
	// 					},
	// 					reviewer: {
	// 						name: 'fulano',
	// 					},
	// 					elaborator: {
	// 						name: 'ciclano',
	// 					},
	// 				},
	// 			},
	// 			{
	// 				email: 'email4@example.com',
	// 				subject: 'Assunto 4',
	// 				date: '2024-09-11',
	// 				status: '',
	// 				id: 104,
	// 				group: {
	// 					name: 'Grupo D',
	// 					reportSendingFrom: {
	// 						name: 'Remetente 4',
	// 					},
	// 					reviewer: {
	// 						name: 'fulano',
	// 					},
	// 					elaborator: {
	// 						name: 'ciclano',
	// 					},
	// 				},
	// 			},
	// 		],
	// 	}
	// }

	// get dates() {
	// 	return Object.keys(this.emailsGroupedByDate)
	// }

	format(date) {
		return dateHelper.utc.format(date)
	}

	filters = {
		elaborator: '',
		sales: '',
		reviewer: '',
	}

	loadingSend = {}
	selectedClientId: string | null = null
	selectedValue = false
	modalLoading = false
	errorMessage = ''
	get elaborators() {
		return this.$store.state.emails.elaborators
	}

	get sales() {
		return this.$store.state.emails.sales
	}

	get reviewers() {
		return this.$store.state.emails.reviewers
	}

	clientsById = {}
	async checkSelectValue() {
		if (this.selectedClientId) {
			this.selectedValue = true
		} else {
			this.selectedValue = false
		}
	}

	key = 0
	async createEmail($event) {
		this.modalLoading = true
		if (!this.selectedClientId) return
		$event.preventDefault()
		const group = {
			...this.clientsById[this.selectedClientId],
			is_adm: true,
		}

		const resp = await fetch.post('/api/email_logs/create', group)

		if (resp.ok) {
			await this.$store.dispatch('fetchEmailLogsAdm', true)
			this.selectedClientId = null
			this.selectedValue = false
			this.$bvModal.hide('modal-create-email')
			this.$bvToast.toast('Salvo com sucesso', {
				title: 'Novo email',
				noCloseButton: false,
				noAutoHide: true,
				variant: 'success',
				toaster: 'b-toaster-top-center',
			})
		} else {
			this.errorMessage = resp.error
		}
		this.modalLoading = false

		this.key++
	}

	onFilterChange() {
		this.$store.dispatch('filterEmails', this.filters)
	}

	goToSeeAll() {
		const router = this.$router
		router.push({
			name: 'ReportSending',
			params: {
				seeAll: 'ver-todos',
			},
		})
		router.go(0)
	}

	goToSeeNotSent() {
		const router = this.$router
		router.push({
			name: 'ReportSending',
			params: {},
		})
		router.go(0)
	}

	keyFilterDate = 0

	onContext(options) {
		if (options?.selectedFormatted) {
			this.filterDateShow = options?.selectedFormatted
		}
	}

	control = new Control()

	debouncedChange(event) {
		const debouncedChange = this.control.debounce(
			this.onFilterDateShowInput,
			1000,
		)
		debouncedChange(event)
	}

	onFilterDateShowInput($event) {
		const value = $event.target.value
		if (value) {
			this.filterDate = new Date(value)
			this.onSendAtFilterInput(value?.split('/').reverse().join('-'))
		}
	}

	async onSendAtFilterInput(value) {
		this.loading = true
		const options = {
			seeAll: this.seeAll === 'ver-todos',
			date: value,
		}

		await this.$store.dispatch('fetchEmailLogsAdm', options)

		this.loading = false
	}
}

function sortByDate(emailsGroupedByDate) {
	if (!emailsGroupedByDate) return null
	const datesArray = Object.keys(emailsGroupedByDate)

	datesArray.sort((a, b) => {
		const middayString = 'T12:00:00.000Z'
		const dateA = new Date(a + middayString)
		const dateB = new Date(b + middayString)
		if (dateA < dateB) {
			return 1
		}
		if (dateA > dateB) {
			return -1
		}
		return 0
	})

	return datesArray
}
